<template>
  <div class="adhoc-drive-edit-page">
    <div class="row">
      <div class="col12">
        <!-- ***********************  GENERAL INFO   *********************************** -->
        <div class="spl-h3 spl-h3--first">
          General Info
        </div>
        <div class="row">
          <div class="col3">
            <form-label>Date Of Order</form-label>
            <form-datepicker
              v-model="date"
              @input="handleDateInput($event, '', 'date')" />
          </div>
          <div class="col3">
            <form-label>Country</form-label>
            <country-select
              v-model="defaultFilter.Country_ID"
              :options="countryOptions"
              data-cy="edit-adhoc-drive-country"
              track-by="value"
              label="label"
              placeholder="Country" />
          </div>
          <div class="col3">
            <form-label>Customer</form-label>
            <customer-select
              v-model="defaultFilter.Customer_ID"
              :options="customerOptions"
              data-cy="edit-adhoc-drive-customer"
              track-by="value"
              label="label"
              placeholder="Customer" />
          </div>
          <div class="col3">
            <form-label>Provider</form-label>
            <provider-select
              v-model="defaultFilter.Provider_ID"
              :options="activeProviderOptions"
              data-cy="edit-adhoc-drive-provider"
              track-by="value"
              label="label"
              placeholder="Provider" />
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col12">
        <!-- *********************** ADDRESS INFO   *********************************** -->
        <div class="spl-h3">
          Address Info
        </div>
        <div class="row">
          <div class="col3">
            <form-label>Description</form-label>
            <form-input v-model="defaultFilter.Description" data-cy="edit-adhoc-drive-postal-code-from" />
          </div>
          <div class="col3">
            <form-label>From City</form-label>
            <form-input v-model="defaultFilter.From_City" data-cy="edit-adhoc-drive-postal-code-from" />
          </div>
          <div class="col3">
            <form-label>To City</form-label>
            <form-input v-model="defaultFilter.To_City" data-cy="edit-adhoc-drive-postal-code-from" />
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col12">
        <!-- *********************** VOLUMES AND COSTS   *********************************** -->
        <div class="spl-h3">
          Volumes and Costs
        </div>
        <div class="row">
          <div class="col3">
            <form-label>No.Of Parcels</form-label>
            <form-input v-model="defaultFilter.Number_Of_Parcels" data-cy="edit-adhoc-drive-postal-code-to" />
          </div>
          <div class="col3">
            <form-label>Weight</form-label>
            <form-input v-model="defaultFilter.Weight" data-cy="edit-adhoc-drive-city" />
          </div>
          <div class="col3">
            <form-label>Cost Coverage By</form-label>
            <form-filtered-select
              v-model="defaultFilter.Cost_Coverage_By"
              :options="costCoverageOptions"
              :selected-key="defaultFilter.Cost_Coverage_By" />
          </div>
          <div class="col3">
            <form-label>Agreed Cost</form-label>
            <form-input v-model="defaultFilter.Agreed_Cost" data-cy="edit-adhoc-drive-city" />
          </div>
        </div>
        <div class="row">
          <div class="col3">
            <form-label>Agreed Price</form-label>
            <form-input v-model="defaultFilter.Agreed_Price" data-cy="edit-adhoc-drive-city" />
          </div>
          <div class="col3">
            <form-label>Currency</form-label>
            <currency-select
              v-model="defaultFilter.Currency_ID"
              :options="currencyOptions"
              data-cy="edit-adhoc-drive-currency"
              track-by="value"
              label="label"
              placeholder="Currency" />
          </div>
          <div class="col3">
            <form-label>Service Leg</form-label>
            <service-leg-select
              v-model="defaultFilter.Service_Leg_ID"
              :options="service_LegOptions"
              data-cy="edit-adhoc-drive-service-leg"
              track-by="value"
              label="label"
              placeholder="Service Leg" />
          </div>
        </div>
      </div>
    </div>
    <div class="row spl-h3--last">
      <div class="col12">
        <!-- *********************** REFERENCES   *********************************** -->
        <div class="spl-h3">
          References
        </div>
        <div class="row">
          <div class="col3">
            <form-label>Counter Number</form-label>
            <form-input v-model="defaultFilter.Counter_Number" data-cy="edit-adhoc-drive-postal-code-from" />
          </div>
          <div class="col3">
            <form-label>AWB Number</form-label>
            <form-input v-model="defaultFilter.AWB_Reference" data-cy="edit-adhoc-drive-awb-number" />
          </div>
          <div class="col3">
            <form-label>Forwarder Reference</form-label>
            <form-input v-model="defaultFilter.Forwarder_Reference" data-cy="edit-adhoc-drive-forwarder-reference" />
          </div>
          <div class="col3">
            <form-label>Comments</form-label>
            <form-input v-model="defaultFilter.Comments" data-cy="edit-adhoc-drive-city" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Helpers from '@/helpers.vue'
import constants from '@/constants'
import { set, cloneDeep } from 'lodash'
import { mapGetters, mapMutations, mapState } from 'vuex'
import { AdhocDrive } from '@/webApi/DataModels'
import moment from 'moment'

export default {
  mixins: [Helpers],
  data () {
    return {
      date: moment().toISOString(true),
      defaultFilter: {
        Provider_ID: {},
        Customer_ID: {},
        Country_ID: {},
        Date_Of_Order: moment().toISOString(true),
        From_City: '',
        To_City: '',
        Description: '',
        Number_Of_Parcels: '',
        Weight: '',
        Cost_Coverage_By: 'time:matters',
        Agreed_Cost: '',
        Agreed_Price: '',
        Currency_ID: {},
        Service_Leg_ID: {},
        Comments: '',
        AWB_Reference: '',
        Forwarder_Reference: ''
      },
      constants,
      selectedCountry: {},
      selectedCustomer: {},
      selectedProvider: {},
      selectedCurrency: {},
      selectedServiceLeg: {},
      costCoverageOptions: [
        { value: 'time:matters', label: 'time:matters' },
        { value: 'Customer', label: 'Customer' },
        { value: 'Subcontractor', label: 'Subcontractor' }
      ]
    }
  },
  created () {
    if (this.currentEditAdhocDrive.Date_Of_Order) {
      this.date = this.formatDate(this.currentEditAdhocDrive.Date_Of_Order, false, 'YYYY-MM-DD')
    }
  },
  computed: {
    ...mapGetters('provider', ['activeProviderOptions']),
    ...mapGetters('country', ['countryOptions']),
    ...mapGetters('customer', ['customerOptions']),
    ...mapGetters('currency', ['currencyOptions']),
    ...mapState('adhocDrive', ['currentEditAdhocDrive']),
    ...mapGetters('serviceLeg', ['service_LegOptions'])
  },
  watch: {
    selectedCountry: function () {
      if (this.selectedCountry !== -1) {
        this.defaultFilter.Country_ID = this.selectedCountry
        this.setCurrentEditAdhocDrive(set(cloneDeep(this.currentEditAdhocDrive), 'Adhoc_Filter', this.defaultFilter))
      }
    },
    selectedCustomer: function () {
      if (this.selectedCustomer !== -1) {
        this.defaultFilter.Customer_ID = this.selectedCustomer
      } else {
        this.defaultFilter.Customer_ID = {}
      }
      this.setCurrentEditAdhocDrive(set(cloneDeep(this.currentEditAdhocDrive), 'Adhoc_Filter', this.defaultFilter))
    },
    selectedProvider: function () {
      if (this.selectedProvider !== -1) {
        this.defaultFilter.Provider_ID = this.selectedProvider
        this.setCurrentEditAdhocDrive(set(cloneDeep(this.currentEditAdhocDrive), 'Adhoc_Filter', this.defaultFilter))
      }
    },
    selectedCurrency: function () {
      if (this.selectedCurrency !== -1) {
        this.defaultFilter.Currency_ID = this.selectedCurrency
        this.setCurrentEditAdhocDrive(set(cloneDeep(this.currentEditAdhocDrive), 'Adhoc_Filter', this.defaultFilter))
      }
    },
    selectedServiceLeg: function () {
      if (this.selectedServiceLeg !== -1) {
        this.defaultFilter.Service_Leg_ID = this.selectedServiceLeg
        this.setCurrentEditAdhocDrive(set(cloneDeep(this.currentEditAdhocDrive), 'Adhoc_Filter', this.defaultFilter))
      }
    },
    defaultFilter: {
      handler: function () {
        // update the adhoc filter everytime the parcel filter changes
        this.setCurrentEditAdhocDrive(set(cloneDeep(this.currentEditAdhocDrive), 'Adhoc_Filter', this.defaultFilter))
      },
      deep: true
    }
  },
  mounted () {
    this.defaultFilter = cloneDeep(this.currentEditAdhocDrive)
    if (this.defaultFilter.Country_ID < 0) {
      this.defaultFilter.Country_ID = {}
    }
    if (this.defaultFilter.Customer_ID < 0) {
      this.defaultFilter.Customer_ID = {}
    }
    if (this.defaultFilter.Provider_ID < 0) {
      this.defaultFilter.Provider_ID = {}
    }
    if (this.defaultFilter.Currency_ID < 0) {
      this.defaultFilter.Currency_ID = {}
    }
    if (this.defaultFilter.Service_Leg_ID < 0) {
      this.defaultFilter.Service_Leg_ID = {}
    }
    if (this.currentEditAdhocDrive.Country_ID !== -1) {
      this.set_Country_Dropdown_By_ID(this.currentEditAdhocDrive.Country_ID)
    }
    if (this.currentEditAdhocDrive.Customer_ID !== -1) {
      this.set_Customer_Dropdown_By_ID(this.currentEditAdhocDrive.Customer_ID)
    }
    if (this.currentEditAdhocDrive.Provider_ID !== -1) {
      this.set_Provider_Dropdown_By_ID(this.currentEditAdhocDrive.Provider_ID)
    }
    if (this.currentEditAdhocDrive.Currency_ID !== -1) {
      this.set_Currency_Dropdown_By_ID(this.currentEditAdhocDrive.Currency_ID)
    }
    if (this.currentEditAdhocDrive.Service_Leg_ID !== -1) {
      this.set_Service_Leg_Dropdown_By_ID(this.currentEditAdhocDrive.Service_Leg_ID)
    }
  },
  methods: {
    ...mapMutations('adhocDrive', ['setCurrentEditAdhocDrive']),
    onCountriesSelected (countries) {
      this.Country_ID = countries
    },
    set_Country_Dropdown_By_ID (countryID) {
      for (var i in this.countryOptions) {
        if (this.countryOptions[i].value === countryID) {
          this.selectedCountry = this.countryOptions[i]
          return
        }
      }
    },
    set_Customer_Dropdown_By_ID (customerID) {
      for (var i in this.customerOptions) {
        if (this.customerOptions[i].value === customerID) {
          this.selectedCustomer = this.customerOptions[i]
          return
        }
      }
    },
    set_Provider_Dropdown_By_ID (providerID) {
      for (var i in this.activeProviderOptions) {
        if (this.activeProviderOptions[i].value === providerID) {
          this.selectedProvider = this.activeProviderOptions[i]
          return
        }
      }
    },
    set_Currency_Dropdown_By_ID (currencyID) {
      for (var i in this.currencyOptions) {
        if (this.currencyOptions[i].value === currencyID) {
          this.selectedCurrency = this.currencyOptions[i]
          return
        }
      }
    },
    set_Service_Leg_Dropdown_By_ID (serviceLegID) {
      for (var i in this.service_LegOptions) {
        if (this.service_LegOptions[i].value === serviceLegID) {
          this.selectedServiceLeg = this.service_LegOptions[i]
          return
        }
      }
    },
    // Handles input changes in the date fiels,
    // only one selection is possible so it
    // resets the selected date object if another
    // type is selected
    handleDateInput (value, type, specifier) {
      if (specifier === 'date') {
        this.defaultFilter.Date_Of_Order = this.formatDate(value, false, 'YYYY-MM-DD')
      }
      this.writeDateFilter()
      this.$forceUpdate()
    },
    writeDateFilter () {
      // Everytime the date page is changed write it into a usable format for storing
      var adhocDrive:AdhocDrive = cloneDeep(this.currentEditAdhocDrive) as AdhocDrive
      this.setCurrentEditAdhocDrive(adhocDrive)
    }
  }
}
</script>

<style lang="scss">
  @import '../../../variables.scss';

  .adhoc-drive-edit-page {
    margin-bottom: 100px;
    background-color: #fff7e7;
    & .spl-h3 {
      margin-top: 30px;
      margin-bottom: 40px;
      position: relative;

      &::before {
        content: "";
        border-bottom: 3px solid black;
        opacity: 0.3;
        width: 30px;
        position: absolute;
        bottom: -13px;
      }
    }
    & .spl-h3--first {
      padding-top: 30px;
      margin-top: 0px !important;
    }
    & .spl-h3--last {
      padding-bottom: 100px;
    }
    &__date {
      display: grid;
      grid-template-columns: 24% 24% 24% 24%;
      grid-gap: 7px;
      width: 100%;
      padding-top: 1%;
      position: relative;

      &--active {
        background-color: $grey_80 !important;
      }

      &--close-adhoc-drive, &--open-adhoc-drive {
        position: relative;
      }

      div {
        background-color: $grey_95;
        border-radius: 5px;
        padding: 3px;
      }

      .spl-checkbox-group__item__label {
        margin-bottom: 10px;
      }
    }

    &__adhoc-drive {
      float: left;
      display: flex;
    }

    &__fields, &__postal, &__references, &__weekend-delivery {
      display: grid;
      grid-template-columns: 24% 24% 24% 24%;
      grid-gap: 7px;
      width: 100%;
      padding-top: 1%;
      div {
        margin-bottom: 10px;
      }
    }
    &__fields:last-child, &__postal:last-child, &__references:last-child, &__weekend-delivery:last-child {
      padding-bottom: 100px;
    }
  }
</style>
